import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    account: {
        auxiliary: {},
    },
    registration: {
        auxiliary: {
            checked: false,
            re_captcha: false,
            active: false,
        },
    },
    login: {
        auxiliary: {},
    },
    'reset-password': {
        auxiliary: {},
    },
    'temporary-password': {
        auxiliary: {},
    },
    'forgot-user-id': {
        auxiliary: {},
    },
    'fee-and-summary-report': {
        auxiliary: {},
    },
}

export const accountSlice = createSlice({
    name: 'account',
    initialState,
    reducers: {
        createAccountData: (state, action) => {
            if (action?.payload) {
                if (
                    action?.['payload']?.['digital_name'] &&
                    action?.['payload']?.['values']
                ) {
                    state[action?.payload?.digital_name] = {
                        ...state?.[action?.payload?.digital_name],
                        values: action?.payload?.values,
                    }
                }
            }
        },
        createAccountValidity: (state, action) => {
            if (action?.payload) {
                if (
                    action?.['payload']?.['digital_name'] &&
                    action?.['payload']?.['errors']
                ) {
                    state[action?.payload?.digital_name] = {
                        ...state?.[action?.payload?.digital_name],
                        errors: action?.payload?.errors,
                    }
                }
            }
        },
        createAccountAuxiliary: (state, action) => {
            return state, action
        },
        updateAccountData: (state, action) => {
            if (action?.payload) {
                if (
                    action?.['payload']?.['digital_name'] &&
                    action?.['payload']?.['values']
                ) {
                    state[action?.payload?.digital_name] = {
                        ...state?.[action?.payload?.digital_name],
                        values: {
                            ...state?.[action?.payload?.digital_name]?.values,
                            ...action?.payload?.values,
                        },
                    }
                }
            }
        },
        updateAccountValidity: (state, action) => {
            if (action?.payload) {
                if (
                    action?.['payload']?.['digital_name'] &&
                    action?.['payload']?.['errors']
                ) {
                    state[action?.payload?.digital_name] = {
                        ...state?.[action?.payload?.digital_name],
                        errors: {
                            ...state?.[action?.payload?.digital_name]?.errors,
                            ...action?.payload?.errors,
                        },
                    }
                }
            }
        },
        updateAccountAuxiliary: (state, action) => {
            if (action?.payload) {
                if (
                    action?.['payload']?.['digital_name'] &&
                    action?.['payload']?.['auxiliary']
                ) {
                    state[action?.payload?.digital_name] = {
                        ...state?.[action?.payload?.digital_name],
                        auxiliary: {
                            ...state?.[action?.payload?.digital_name]
                                ?.auxiliary,
                            ...action?.payload?.auxiliary,
                        },
                    }
                }
            }
        },
        deleteAccountData: (state, action) => {
            if (action?.payload) {
                if (action?.['payload']?.['digital_name']) {
                    state[action?.payload?.digital_name] = {
                        ...state?.[action?.payload?.digital_name],
                        values: {},
                    }
                }
            }
        },
        deleteAccountValidity: (state, action) => {
            if (action?.payload) {
                if (action?.['payload']?.['digital_name']) {
                    state[action?.payload?.digital_name] = {
                        ...state?.[action?.payload?.digital_name],
                        errors: {},
                    }
                }
            }
        },
        deleteAccountAuxiliary: (state, action) => {
            if (action?.payload) {
                if (action?.['payload']?.['digital_name']) {
                    state[action?.payload?.digital_name] = {
                        ...state?.[action?.payload?.digital_name],
                        auxiliary: {},
                    }
                }
            }
        },
        patchAccountData: (state, action) => {
            if (action?.payload) {
                if (
                    action?.['payload']?.['digital_name'] &&
                    action?.['payload']?.['values']
                ) {
                    state[action?.payload?.digital_name] = {
                        ...state?.[action?.payload?.digital_name],
                        values: {
                            ...action?.payload?.values,
                        },
                    }
                }
            }
        },
        patchAccountAuxiliary: (state, action) => {
            if (action?.payload) {
                if (
                    action?.['payload']?.['digital_name'] &&
                    action?.['payload']?.['auxiliary']
                ) {
                    state[action?.payload?.digital_name] = {
                        ...state?.[action?.payload?.digital_name],
                        auxiliary: {
                            ...action?.payload?.auxiliary,
                        },
                    }
                }
            }
        },
    },
})

export const selectAccount = (state) => state.account
export const {
    createAccountData,
    createAccountValidity,
    createAccountAuxiliary,
    updateAccountData,
    updateAccountValidity,
    updateAccountAuxiliary,
    deleteAccountData,
    deleteAccountValidity,
    deleteAccountAuxiliary,
    patchAccountData,
    patchAccountAuxiliary,
} = accountSlice.actions
export default accountSlice.reducer
